/* eslint-disable */
import * as test from './mock/test'
import * as items from './mock/items'
import * as clients from './mock/clients'
import * as accounts from './mock/accounts'
import * as warehouses from './mock/warehouses'
import * as projects from './mock/projects'
import * as material_conditions from './mock/material_conditions'
import * as packing_statuses from './mock/packing_statuses'
import * as transaction_types from './mock/transaction_types'
import * as transactions from './mock/transactions'

import * as updates from './mock/updates'
import * as spoofing from './mock/_spoofing'

/* updates data interceptor : used to merge real api updates with mock updates */
export const update_interceptor = updates.update_interceptor;

/**
 * ============================================================
 * registering api mocks
 * ------------------------------------------------------------
 * - to disable mock for certain sections, just comment it out.
 * - to disable mock all together, set VUE_APP_ENABLE_API_MOCKS
 *   env variable to false
 * ============================================================
 */

test.register_mock();
items.register_mock();
clients.register_mock();
accounts.register_mock();
warehouses.register_mock();
projects.register_mock();
material_conditions.register_mock();
packing_statuses.register_mock();
transaction_types.register_mock();
transactions.register_mock();

/* activate this when using mocks only and no outside apis */
updates.register_mock();


/* ======================================================================== */
/* enable method spoofing, MUST be called last after all mock registrations */
spoofing.enableMethodSpoofing(['delete']);
